const romanCharactersOnly = (value) => {
  const pattern = /^[A-Za-z\s.,'\-]+$/;

  if (!(pattern.test(value))) {
    return 'errors.formFields.aToZOnly';
  }
};

export default romanCharactersOnly;
